export default "__VITE_ASSET__ff3e605f__"